/**
 * A refusal in the reader's language. The server sends a code and parameters, never a sentence for the screen; the
 * screen prints errors.<code> with the parameters. The server's English sentence and any detail stay out of the page.
 *
 * PROVENANCE: C:\Olivia\web\src\lib\errors.ts @ f92475e, copied 2026-10-12 (the pattern of Valentin's ErrorNote).
 * CHANGES: no coded parameters yet (Olivia's roles, states and anchors); the generic sentence by status is kept.
 */

import type { Translate } from '../i18n/core'
import { isMessageKey } from '../i18n/core'
import type { MessageKey } from '../i18n/en'
import { ApiError } from './api'

/** The sentence for a refusal by its code; a code this app does not know answers with the generic one of its status. */
export function refusalText(code: string, status: number, params: Readonly<Record<string, string | number>> | undefined, t: Translate): string {
  const key = `errors.${code}`
  if (isMessageKey(key)) return t(key, { ...(params ?? {}) })
  const generic: MessageKey = status === 403 ? 'errors.FORBIDDEN' : status === 404 ? 'errors.NOT_FOUND' : status === 409 ? 'errors.CONFLICT' : status >= 400 && status < 500 ? 'errors.INVALID' : 'errors.INTERNAL'
  return t(generic)
}

/** Any error a screen shows, in words: a refusal by its code, a failure to reach the server by a fixed sentence. */
export function errorText(error: unknown, t: Translate): string {
  if (error instanceof ApiError) return refusalText(error.code, error.status, error.params, t)
  return t('errors.UNREACHABLE')
}
